// extracted by mini-css-extract-plugin
export default {"no-mobile-apps":"EmptyState__no-mobile-apps__OP6Fp"};